import type { BusinessUnit } from '@backend/lib-l10n';

import { businessUnits, type Page } from '~/config/businessUnits';
import { createSlug } from '~/utils/slug';

export const buildGetPageHref = ({ baseHref, businessUnit }: { baseHref: string; businessUnit: BusinessUnit }) => {
  const { paths } = businessUnits[businessUnit];
  return (page: Page, ...params: string[]) => `${baseHref}/${[paths[page], ...params.map(createSlug)].join('/')}`;
};
